import { createFileRoute, useSearch } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { useVerifyEmail } from "../data/auth/hooks";

export const Route = createFileRoute("/verify-email")({
  component: RouteComponent,
  validateSearch: (search: Record<string, string>) => {
    const { token } = search;

    return {
      token: token || "",
    };
  },
});

function RouteComponent() {
  const { token } = useSearch({ from: "/verify-email" });

  const verifyEmail = useVerifyEmail();
  const [isVerifying, setIsVerifying] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    // Only attempt verification if both email and code are present
    if (token && !isVerifying && !verifyEmail.isPending) {
      setIsVerifying(true);
      verifyEmail.mutate(
        { token },
        {
          onError: (err) => {
            setError(err.message);
            setIsVerifying(false);
          },
        }
      );
    }
  }, [token, verifyEmail, isVerifying]);

  if (!token) {
    return (
      <div className="flex flex-col items-center justify-center p-8 text-center">
        <h1 className="text-2xl font-bold mb-4">Invalid Verification Link</h1>
        <p className="mb-4">
          The verification link is missing required parameters.
        </p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex flex-col items-center justify-center p-8 text-center">
        <h1 className="text-2xl font-bold mb-4">Verification Failed</h1>
        <p className="mb-4">{error}</p>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center p-8 text-center">
      <h1 className="text-2xl font-bold mb-4">
        {verifyEmail.isPending ? "Verifying Your Email..." : "Email Verified!"}
      </h1>
      <p className="mb-4">
        {verifyEmail.isPending
          ? "Please wait while we verify your email address."
          : "Your email has been successfully verified. You will be redirected to the dashboard."}
      </p>
    </div>
  );
}
